export default "__VITE_ASSET__OraRPTzq__"